import { Colors } from '../../components/Colors';
import { Variables } from '../../components/Variables';
export var fontSizeList = {
  'Dizraptor/Title XXL': Variables.typography.dizraptor.titleXXL.fs,
  'Dizraptor/Title XL': Variables.typography.dizraptor.titleXL.fs,
  'Dizraptor/Title L': Variables.typography.dizraptor.titleL.fs,
  'Dizraptor/Title L Compact': Variables.typography.dizraptor.titleLCompact.fs,
  'Dizraptor/Body': Variables.typography.dizraptor.body.fs,
  'Dizraptor/Footnote': Variables.typography.dizraptor.footnote.fs,
  'Dizraptor/Note': Variables.typography.dizraptor.note.fs,
  'Dizraptor/Subnote': Variables.typography.dizraptor.subnote.fs,
  'DizraptorAccent/Heading XL': Variables.typography.dizraptorAccent.headingXL.fs,
  'DizraptorAccent/Heading': Variables.typography.dizraptorAccent.heading.fs,
  'DizraptorAccent/Title XXL': Variables.typography.dizraptorAccent.titleXXL.fs,
  'DizraptorAccent/Title XL': Variables.typography.dizraptorAccent.titleXL.fs,
  'DizraptorAccent/Title L': Variables.typography.dizraptorAccent.titleL.fs
};
export var lineHeightList = {
  'Dizraptor/Title XXL': Variables.typography.dizraptor.titleXXL.lh,
  'Dizraptor/Title XL': Variables.typography.dizraptor.titleXL.lh,
  'Dizraptor/Title L': Variables.typography.dizraptor.titleL.lh,
  'Dizraptor/Title L Compact': Variables.typography.dizraptor.titleLCompact.lh,
  'Dizraptor/Body': Variables.typography.dizraptor.body.lh,
  'Dizraptor/Footnote': Variables.typography.dizraptor.footnote.lh,
  'Dizraptor/Note': Variables.typography.dizraptor.note.lh,
  'Dizraptor/Subnote': Variables.typography.dizraptor.subnote.lh,
  'DizraptorAccent/Heading XL': Variables.typography.dizraptorAccent.headingXL.lh,
  'DizraptorAccent/Heading': Variables.typography.dizraptorAccent.heading.lh,
  'DizraptorAccent/Title XXL': Variables.typography.dizraptorAccent.titleXXL.lh,
  'DizraptorAccent/Title XL': Variables.typography.dizraptorAccent.titleXL.lh,
  'DizraptorAccent/Title L': Variables.typography.dizraptorAccent.titleL.lh
};
export var getColor = function getColor(view) {
  switch (view) {
    case 'disabled':
      return Colors.text.disabled;
    case 'hint':
      return Colors.text.defaultDim;
    case 'negative':
      return Colors.text.alert;
    case 'positive':
      return Colors.text.primary;
    case 'rejected':
      return Colors.text.error;
    case 'success':
      return Colors.text.success;
    case 'normal':
      return Colors.text["default"];
    default:
      return null;
    // Если задать цвет по умолчанию для Text, то он перестанет наследовать родитеский цвет, а это необходиомо в некоторых случаях. Например в history, когда всей строке (tr) таблицы задается серый цвет, чтобы показать, что она задизейблена
  }
};

export var getFontFamily = function getFontFamily(font) {
  switch (font) {
    case 'primary':
      return Variables.primaryFontFamily;
    case 'second':
      return Variables.secondFontFamily;
    default:
      return null;
  }
};
//# sourceMappingURL=utils.js.map